import { useState } from "react";
import { hotBoard, categoryColors } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function HotBoard() {
  const [list, setList] = useState(hotBoard);

  const refresh = () => {
    // 模拟刷新榜单：打乱前三之外的顺序并更新“刷新于”时间
    const base = [...hotBoard];
    const head = base.slice(0, 3);
    const tail = base.slice(3).sort(() => Math.random() - 0.5);
    setList([...head, ...tail]);
    setUpdated(new Date().toTimeString().slice(0, 5));
  };

  const [updated, setUpdated] = useState("08:02");

  const trendIcon = (trend: string) => {
    if (trend === "up") return <i className="ri-arrow-up-line text-accent-600" title="上升"></i>;
    if (trend === "down") return <i className="ri-arrow-down-line text-foreground-400" title="下降"></i>;
    return <span className="rounded bg-secondary-200 px-1.5 py-0.5 text-[10px] font-bold text-secondary-800">新</span>;
  };

  return (
    <section id="hot" className="chigua-container mx-auto scroll-mt-20 py-14 md:py-20">
      <SectionHeading
        eyebrow="实时热榜"
        title="今日热搜 · 全网正在吃什么瓜"
        desc="每小时滚动更新的高热度事件榜单，标注升温、降温与新鲜上榜，一眼看清舆论风向。"
      />
      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {/* Hot list panel */}
        <div className="rounded-[28px] border border-background-200 bg-background-50 p-5 md:p-7 lg:col-span-2">
          <div className="flex items-center justify-between border-b border-background-200 pb-4">
            <div className="flex items-center gap-2 text-sm font-semibold text-foreground-700">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
              </span>
              全站热搜榜 · 刷新于 {updated}
            </div>
            <button
              type="button"
              onClick={refresh}
              className="chip chip-idle"
            >
              <i className="ri-refresh-line mr-1"></i> 刷新
            </button>
          </div>

          <ol className="mt-2 grid grid-cols-1 gap-x-6 sm:grid-cols-2">
            {list.map((h) => (
              <li key={h.rank}>
                <div className="group flex cursor-pointer items-center gap-3 rounded-2xl px-2 py-3 transition-colors hover:bg-background-100">
                  <span
                    className={`font-display w-7 shrink-0 text-center text-xl ${
                      h.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                      {h.title}
                    </p>
                    <div className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                      <span className={`rounded px-1.5 py-0.5 text-[10px] font-semibold text-background-50 ${categoryColors[h.tag] || "bg-foreground-600"}`}>
                        {h.tag}
                      </span>
                      <span>{h.heat}热度</span>
                    </div>
                  </div>
                  <span className="flex w-6 shrink-0 justify-center">{trendIcon(h.trend)}</span>
                </div>
              </li>
            ))}
          </ol>
        </div>

        {/* Radar side panel */}
        <aside className="flex flex-col gap-6">
          <div className="rounded-[28px] bg-primary-600 p-6 text-background-50">
            <div className="flex items-center justify-between">
              <h3 className="font-display text-lg">情报雷达</h3>
              <i className="ri-radar-line text-xl"></i>
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center justify-between gap-3 rounded-2xl bg-primary-500/60 px-4 py-3">
                <span className="flex items-center gap-2"><i className="ri-flashlight-fill"></i> 正在发酵</span>
                <span className="rounded-full bg-background-50 px-2 py-0.5 text-xs font-bold text-primary-600">3 条</span>
              </li>
              <li className="flex items-center justify-between gap-3 rounded-2xl bg-primary-500/60 px-4 py-3">
                <span className="flex items-center gap-2"><i className="ri-refund-fill"></i> 反转进行时</span>
                <span className="rounded-full bg-background-50 px-2 py-0.5 text-xs font-bold text-primary-600">2 条</span>
              </li>
              <li className="flex items-center justify-between gap-3 rounded-2xl bg-primary-500/60 px-4 py-3">
                <span className="flex items-center gap-2"><i className="ri-error-warning-fill"></i> 待核实爆料</span>
                <span className="rounded-full bg-background-50 px-2 py-0.5 text-xs font-bold text-primary-600">5 条</span>
              </li>
            </ul>
          </div>

          <div className="rounded-[28px] border border-accent-200 bg-accent-50 p-6">
            <h3 className="flex items-center gap-2 font-display text-lg text-accent-800">
              <i className="ri-shield-check-line"></i> 吃瓜守则
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              先看信源、再看时间线、最后才站队。吃瓜中心对每一条「未证实」信息都会明确标注，绝不替谣言推波助澜。
            </p>
            <a href="#faq" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-accent-700 hover:text-accent-800">
              阅读完整守则 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </aside>
      </div>
    </section>
  );
}